module.exports = __webpack_public_path__ + "static/media/crypto-collectors.214c5301.png";